import Vue from "vue";
import axios from "axios";

let el = document.querySelector("#updates-view");
if (el) {
	new Vue({
		el,
		data() {
			const startYear = 2023;
			const currentYear = new Date().getFullYear();
			const yearRange = Array.from(
				{ length: currentYear - startYear + 1 },
				(v, k) => startYear + k
			);

			const months = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];

			const updateTypes = [
				{ value: "construction", label: "Construction Update" },
				{ value: "milestone", label: "Major Project Milestone" },
				{ value: "road-access", label: "Temporary Road Access Update" },
			];

			return {
				loading: true,
				failed: false,
				page: 1,
				per_page: 6,
				updates: [],
				filters: {
					month: this.QueryParam("month") || false,
					year: this.QueryParam("year") || false,
					update_type: this.QueryParam("update_type") || false,
					post_id: document.getElementById("community-id").value,
				},
				filtersOptions: {
					month: months,
					year: yearRange,
					update_type: updateTypes,
				},
			};
		},
		computed: {
			filteredYears() {
				return this.filtersOptions.year;
			},
			limit() {
				return this.page * this.per_page;
			},
			next() {
				return this.updates.length > this.limit;
			},
		},
		methods: {
			setLimit(limit = 6) {
				this.page = 1;
				this.per_page = limit;
				this.getUpdates();
			},
			getUpdates() {
				this.loading = true;
				this.failed = false;

				const params = {
					per_page: this.per_page,
					page: this.page,
					community_update: this.filters.post_id,
				};

				axios
					.get(`/wp-json/wp/v2/updates?_embed`, { params })
					.then((response) => {
						const filteredUpdates = [];
						this.allUpdates = response.data;
						this.loading = false;

						response.data.forEach((update) => {
							let match = true;

							if (this.filters.post_id) {
								if (
									update.acf.community_update.ID !=
									this.filters.post_id
								) {
									match = false;
								}
							}

							if (this.filters.update_type) {
								if (
									update.acf.update_type &&
									update.acf.update_type.value !==
										this.filters.update_type
								) {
									match = false;
								}
							}

							const postDate = new Date(update.date);
							if (this.filters.year) {
								const filterYear = parseInt(
									this.filters.year,
									10
								);

								if (postDate.getFullYear() !== filterYear) {
									match = false;
								}

								if (this.filters.month) {
									const filterMonthIndex =
										this.filtersOptions.month.indexOf(
											this.filters.month
										);

									if (
										postDate.getMonth() !== filterMonthIndex
									) {
										match = false;
									}
								}
							} else if (this.filters.month) {
								const filterMonthIndex =
									this.filtersOptions.month.indexOf(
										this.filters.month
									);

								if (postDate.getMonth() !== filterMonthIndex) {
									match = false;
								}
							}

							if (match) {
								filteredUpdates.push(update);
							}
						});

						this.updates =
							this.page === 1
								? filteredUpdates
								: [...this.updates, ...filteredUpdates];

						this.loading = false;
						this.failed = false;
					})
					.catch((error) => {
						console.error("API Request Failed:", error);
						this.loading = false;
						this.failed = true;
					});
			},
			filter() {
				this.updates = [];
				this.page = 1;
				this.getUpdates();
			},
			reset() {
				this.updates = [];
				this.page = 1;
				this.filters = {
					month: false,
					year: false,
					update_type: false,
					post_id:
						document.getElementById("community-id").value || null,
				};
				this.getUpdates();
			},
			showMore() {
				this.page++;
				this.getUpdates();
			},
			QueryParam(param) {
				const query = new URLSearchParams(window.location.search);
				return query.get(param) || false;
			},
		},
		mounted() {
			this.getUpdates();
		},
	});
}



// WEBPACK FOOTER //
// ./assets/js/components/_updates.js